import StyledTabs from 'app/components/StyledTabs';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Layout } from '../layouts';
import { ACCOUNT_MNG_MENU } from '../layouts/AccountManager';
import BookingHistory from './components/BookingHistory';
import CheckBookingSlots from './components/CheckBookingSlots';

export enum MAIN_TABS {
  BOOKING = 'booking',
  BOOKING_HISTORY = 'booking-history',
}
const BookingSlots = () => {
  const { search } = useLocation();
  const screen = new URLSearchParams(search).get('screen') as MAIN_TABS;
  const history = useHistory();
  const translations = useSelector(selectTranslations);
  const activeTab = Object.values(MAIN_TABS).includes(screen)
    ? screen
    : MAIN_TABS.BOOKING;
  const handleTabChange = (tab: string) => {
    const targetTab = tab as MAIN_TABS;
    const query =
      targetTab === MAIN_TABS.BOOKING_HISTORY ? '?screen=booking-history' : '';
    history.replace(`/restaurant/booking-slots${query}`);
  };
  return (
    <Layout menuActive={ACCOUNT_MNG_MENU.BOOKING_SLOTS}>
      <StyledTabs activeKey={activeTab} onChange={handleTabChange}>
        <StyledTabs.TabPane
          key={MAIN_TABS.BOOKING}
          tab={translations?.['b2b.txt.bookingLookup']?.toUpperCase() ?? ''}
        >
          <CheckBookingSlots />
        </StyledTabs.TabPane>
        <StyledTabs.TabPane
          key={MAIN_TABS.BOOKING_HISTORY}
          tab={translations?.['b2b.txt.bookingHistory']?.toUpperCase() ?? ''}
        >
          <BookingHistory activeTab={activeTab} />
        </StyledTabs.TabPane>
      </StyledTabs>
    </Layout>
  );
};
export default BookingSlots;
